<dialog
    ctrlModal
    (onClose)="dismiss.emit()"
    (clickOutside)="dismiss.emit()"
    aria-labelledby="change-payment-method-modal-title"
>
    <ng-container ctrlModalHeader>
        <h3
            id="change-payment-method-modal-title"
            class="m-0:b semibold"
        >
            <i ctrlIcon="edit"></i><span>Bezahlmethode ändern</span>
        </h3>
        <button
            class="close-button button p-0"
            aria-label="Schließen"
            (click)="dismiss.emit()"
        >
            <i ctrlIcon="close"></i>
        </button>
    </ng-container>

    <hr class="ctrl-modal-hr" />

    <form [formGroup]="formGroup">
        <div class="form-control">
            <label for="account-holder-input">Kontoinhaber*: </label>
            <input
                id="account-holder-input"
                type="text"
                formControlName="accountHolder"
                placeholder="Kontoinhaber*"
                [ctrlErrorMessage]="accountHolderErrorMessages"
            />
        </div>

        <div class="form-control">
            <label for="bank-name-input">Bank*: </label>
            <input
                id="bank-name-input"
                type="text"
                formControlName="bankName"
                placeholder="Bank*"
                [ctrlErrorMessage]="bankNameErrorMessages"
            />
        </div>

        <div class="form-control">
            <label for="iban-input">IBAN*: </label>
            <input
                id="iban-input"
                type="text"
                [formControl]="formGroup.controls.iban"
                placeholder="IBAN*"
                [ctrlErrorMessage]="ibanErrorMessages"
            />
        </div>

        <div class="form-control">
            <label for="bic-input">
                @if (isCurrentIbanGerman()) {
                    BIC (nur für Konten außerhalb Deutschlands)
                } @else {
                    BIC*:
                }
            </label>
            <input
                id="bic-input"
                type="text"
                formControlName="bic"
                [placeholder]="isCurrentIbanGerman() ? 'BIC' : 'BIC*'"
                [ctrlErrorMessage]="bicErrorMessages"
            />
        </div>

        @if (mode !== 'editCurrent') {
            <div class="form-control">
                <label for="valid-from-input">Gültig ab*: </label>
                <input
                    id="valid-from-input"
                    type="text"
                    ctrlDateInput
                    formControlName="validFrom"
                    placeholder="tt.mm.jjjj*"
                    [ctrlErrorMessage]="{
                        required: 'Bitte gib an, ab wann die Änderungen in Kraft treten sollen.',
                        dateTooEarly: 'Bitte wähle ein Datum in der Zukunft aus.',
                        dateIsForbidden:
                            'Eine andere geplante Bezahlmethode wird bereits an diesem Tag gültig. Bitte wähle ein anderes Datum aus.',
                        invalidDateFormat: 'Bitte gib ein gültiges Datum an.',
                        dateComponentIsNaN: 'Bitte gib ein gültiges Datum an.',
                        invalidDay: 'Bitte gib ein gültiges Datum an.',
                    }"
                />
            </div>
        }

        <app-required-info />
    </form>

    <div
        ctrlModalFooter
        class="md:m-24:t"
    >
        <app-portal-action-buttons
            confirmText="Abschicken"
            rejectText="Abbrechen"
            [isConfirmDisabled]="formGroup.pristine || formGroup.invalid || updating()"
            (clickConfirm)="handleSubmit()"
            (clickReject)="dismiss.emit()"
            [isUsedToSubmitForm]="true"
        />
    </div>
</dialog>
